import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingInlineEnd: 56,
      paddingInlineStart: 56,

      '@media (max-width: 1180px)': {
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
      },
    },
    groupedByCell: {
      fontWeight: 'bold',
    },
    emptyReportMessageContainer: {
      marginTop: 140,
    },
    quickReports: {
      maxWidth: '33.3%',
      flexBasis: '33.3%',
      borderRight: `0.5px solid ${variables.black10}`,

      '@media (max-width: 1180px)': {
        width: 250,
        maxWidth: 250,
        flexBasis: 'unset',
        display: 'inline-block',
      },
    },
    panels: {
      marginTop: 16,
      marginBottom: 16,

      '@media (max-width: 1180px)': {
        display: 'block',
        overflowX: 'scroll',
        whiteSpace: 'nowrap',
      },
    },
  }),
);
